import Box from '@ilg-totallymoney/ui/components/Box'
import LinkButton from '@ilg-totallymoney/ui/components/LinkButton'

import NotFoundPage from '@components/NotFoundPage'

import { categories } from '@config/categories'

import useAppQueryState from '@hooks/useAppQueryState'

const UnscoredCardNotFound = () => {
    const { getQueryStringWithAppState } = useAppQueryState()

    const categoryPath = categories.BestCards.path

    return (
        <NotFoundPage
            title="Oh! This card can’t be found"
            subtitle="Sorry, the page you requested doesn’t exist. Hit the browser back button or try the link below."
        >
            <Box pt="space30" maxWidth={['100%', '280px']}>
                <LinkButton
                    variant="primary"
                    href={`${
                        process.env.NEXT_PUBLIC_BASE_PATH
                    }/${categoryPath}/?${getQueryStringWithAppState()}`}
                    text="Back to cards"
                />
            </Box>
        </NotFoundPage>
    )
}

export default UnscoredCardNotFound
